module.exports = __webpack_public_path__ + "img/ajax-loader.3659e0c0.gif";